import { streamPerticuleWatchlist } from "@domains/utils/particulatWatchlist";
import sort, { stringSort } from "@domains/utils/sort";
import { PARTICULAR_WATCHLIST, PARTICULAR_WATCHLIST_APPLY_SORT_, PARTICULAR_WATCHLIST_CLEAR_DATA, PARTICULAR_WATCHLIST_CLEAR_SORT, PARTICULAR_WATCHLIST_ERROR, PARTICULAR_WATCHLIST_HIDE_ERROR, PARTICULAR_WATCHLIST_START_LOADER, PARTICULAR_WATCHLIST_STOP_LOADER, PARTICULAR_WATCHLIST_STREAM, } from "../interface/particularWatchlist";
const initialState = {
    data: {},
    presetWatchlist: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    sortData: {
        sortStates: [],
        sortState: {},
        sortedData: {},
    },
};
const applySorting = (sortData) => {
    var _a, _b;
    let pinStockList = [], unpinStockList = [];
    (_a = sortData.sortedData) === null || _a === void 0 ? void 0 : _a.stockList.map((item) => {
        if (item.isPin === "1") {
            pinStockList.push(item);
        }
        else {
            unpinStockList.push(item);
        }
    });
    if (sortData &&
        sortData.sortedData &&
        ((_b = sortData.sortedData.stockList) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        if (sortData.sortState.type && sortData.sortState.type === "string") {
            pinStockList = stringSort(pinStockList, sortData.sortState.key, sortData.sortState.order);
            unpinStockList = stringSort(unpinStockList, sortData.sortState.key, sortData.sortState.order);
        }
        else {
            pinStockList = sort(pinStockList, sortData.sortState.key, sortData.sortState.order);
            unpinStockList = sort(unpinStockList, sortData.sortState.key, sortData.sortState.order);
        }
    }
    let sortedData = {
        stockList: [],
    };
    (pinStockList === null || pinStockList === void 0 ? void 0 : pinStockList.length) > 0 &&
        pinStockList.map((item) => {
            sortedData.stockList.push(item);
        });
    (unpinStockList === null || unpinStockList === void 0 ? void 0 : unpinStockList.length) > 0 &&
        unpinStockList.map((record) => {
            sortedData.stockList.push(record);
        });
    sortData.sortedData = sortedData;
    return sortData;
};
const particularWatchlist = (state = initialState, action) => {
    var _a, _b;
    switch (action.type) {
        case PARTICULAR_WATCHLIST:
            if (action.isPresetCall) {
                return Object.assign(Object.assign({}, state), { presetWatchlist: (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.stockList });
            }
            else {
                // if (state.sortData.sortState.order !== ESortOrder.UNCHANGED) {
                //   console.log(
                //     applySorting({
                //       ...state.sortData,
                //       sortedData: (action.payload as IParticularWatchlistRoot)?.data,
                //     } as IWatchListSortData),
                //     "sorted data after tab change"
                //   );
                //   return {
                //     ...state,
                //     presetWatchlist: (action.payload as IParticularWatchlistRoot)?.data
                //       ?.stockList,
                //     sortData: applySorting({
                //       ...state.sortData,
                //       sortedData: (action.payload as IParticularWatchlistRoot)?.data,
                //     } as IWatchListSortData),
                //   };
                // }
                return Object.assign(Object.assign({}, state), { data: action.payload.data });
            }
        case PARTICULAR_WATCHLIST_STREAM:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { stockList: streamPerticuleWatchlist(state.data.stockList, action.payload) }) });
        case PARTICULAR_WATCHLIST_CLEAR_DATA:
            return Object.assign(Object.assign({}, state), { data: {} });
        case PARTICULAR_WATCHLIST_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PARTICULAR_WATCHLIST_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case PARTICULAR_WATCHLIST_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case PARTICULAR_WATCHLIST_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case PARTICULAR_WATCHLIST_APPLY_SORT_:
            return Object.assign(Object.assign({}, state), { sortData: applySorting(action.payload) });
        case PARTICULAR_WATCHLIST_CLEAR_SORT:
            return Object.assign(Object.assign({}, state), { sortData: Object.assign(Object.assign({}, state.sortData), { sortedData: initialState.sortData.sortedData }) });
        default:
            return Object.assign({}, state);
    }
};
export default particularWatchlist;
